<template>
  <div
    class="small-card product-card"
    :data-gtin="product.gtin"
  >
    <div
      v-if="ecomm"
      class="buy-now-flag__container"
    >
      <div class="product-card__buy-now">
        Buy Now!
      </div>
    </div>
    <img
      :src="product.imageUrl"
      alt=""
    >
    <a
      :href="product.url"
      data-gtmcat="product engagement"
      data-gtmaction="click"
      :data-gtmlabel="product.title | striphtml"
    >
      <span>{{ product.title | striphtml }}</span>
    </a>
  </div>
</template>

<script>
// import Vue from 'vue'
// import VueLazyload from 'vue-lazyload'
 
// Vue.use(VueLazyload)
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'dist/error.png',
//   loading: 'dist/loading.gif',
//   attempt: 1
// })

export default {
  name: "Product",
  components: {
    // eslint-disable-next-line
    // VueLazyload,
  },
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {}
    },
    ecomm: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    
  },
  created() {
    
  },
  methods: {

  }
}
</script>

